import {generatePath} from 'react-router'

export const pathToApp = (module: string, app: string): string => {
  return generatePath('/mcc-portal-ui/client/:module/:app', {module, app})
}

export const pathToFavorite = (id: string): string => {
  return generatePath('/mcc-portal-ui/favorites/:id', {id})
}

export const pathToHardlink = (id: string): string => {
  return generatePath('/mcc-portal-ui/hardlinks/:id', {id})
}

export const pathToHome = (): string => {
  return '/mcc-portal-ui'
}